/**
 * Uses the search enpoint to get all the R4b_Unit objects
 * @type {Backbone.Collection}
 */
module.exports = Backbone.Collection.extend({
	url: App.apiRoot + 'objects/search/',
	comparator: 'level'
})
